import LegalDoc from "./LegalDoc";

export default function CondizioniLegali() {
  return (
    <LegalDoc
      field="legal_conditions"
      overline="Note legali"
      title={<>Condizioni <span className="italic text-[#D47738]">legali</span></>}
      related={[
        { to: "/condizioni-acquisto", label: "Condizioni di acquisto" },
        { to: "/privacy", label: "Privacy Policy" },
        { to: "/politica-rimborso", label: "Politica di rimborso" },
      ]}
    />
  );
}
